/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_Agent_Passkey_Revoke_TitleInputs */



/**
* | output |
* | --- |
* | "Revoke this passkey?" |
*
* @param {Profile_Security_Agent_Passkey_Revoke_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_agent_passkey_revoke_title = /** @type {((inputs?: Profile_Security_Agent_Passkey_Revoke_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_Agent_Passkey_Revoke_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diesen Passkey widerrufen?")
	return /** @type {LocalizedString} */ ("Revoke this passkey?")
});